import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import {
  AddAndAddonsIcon,
  ChatAccessIcon,
  CustomerDBIcon,
  DashboardIcon,
  FaqsIcon,
  FlashMessageIcon,
  FundManagementIcon,
  NotificationsIcon,
  NotifyIcon,
  ProMembershipIcon,
  ReferralAndDiscountsIcon,
  RequestsIcon,
  ReviewsIcon,
  SalesPageIcon,
  ServiceProviderIcon,
  SubscriptionIcon,
  TermsAndConditionIcon,
  TicketManagementIcon,
  UserManagementIcon,
  UserPermissionsIcon,
  categoryIcon,
} from "../../../assets/svg";

export const useSuperAdminSidebarUtils = (t) => {
  let tempMenuGroup = [];

  /* menuItemDashboard */
  const menuItemDashboard = {
    label: t("AppModuleNames.SuperAdmin.Dashboard"),
    icon: DashboardIcon,
    path: baseRouteMakerForSuperAdmin(routes.SUPER_ADMIN_DASHBOARD),
  };
  tempMenuGroup.push(menuItemDashboard);
  /* menuItemDashboard */

  /* menuItemCategories */
  const menuItemCategories = {
    label: t("servicesList.category"),
    icon: categoryIcon,
    path: baseRouteMakerForSuperAdmin(routes.CATEGORIES),
  };
  tempMenuGroup.push(menuItemCategories);
  /* menuItemCategories */

  /* menuItemRequests */
  const menuItemRequests = {
    label: t("AppModuleNames.SuperAdmin.Requests"),
    icon: RequestsIcon,
    path: baseRouteMakerForSuperAdmin(routes.REQUESTS),
  };
  tempMenuGroup.push(menuItemRequests);
  /* menuItemRequests */

  /* menuItemServiceProvider */
  const menuItemServiceProvider = {
    label: t("AppModuleNames.SuperAdmin.ServiceProvider"),
    icon: ServiceProviderIcon,
    path: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER),
  };
  tempMenuGroup.push(menuItemServiceProvider);
  /* menuItemServiceProvider */

  /* menuItemSalesPage */
  const menuItemSalesPage = {
    label: t("AppModuleNames.SuperAdmin.SalesPage"),
    icon: SalesPageIcon,
    path: baseRouteMakerForSuperAdmin(routes.SALES_PAGE),
  };
  tempMenuGroup.push(menuItemSalesPage);
  /* menuItemSalesPage */

  /* menuItemCustomerDB */
  const menuItemCustomerDB = {
    label: t("AppModuleNames.SuperAdmin.CustomerDB"),
    icon: CustomerDBIcon,
    path: baseRouteMakerForSuperAdmin(routes.CUSTOMER_DB),
  };
  tempMenuGroup.push(menuItemCustomerDB);
  /* menuItemCustomerDB */

  /* menuItemSubscription */
  const menuItemSubscription = {
    label: t("AppModuleNames.SuperAdmin.Subscription"),
    icon: SubscriptionIcon,
    path: baseRouteMakerForSuperAdmin(routes.SUBSCRIPTIONS),
  };
  tempMenuGroup.push(menuItemSubscription);
  /* menuItemSubscription */

  /* menuItemAdsAndAddons */
  const menuItemAdsAndAddons = {
    label: t("AppModuleNames.SuperAdmin.AddAndAddons"),
    icon: AddAndAddonsIcon,
    path: baseRouteMakerForSuperAdmin(routes.ADS_AND_ADDONS),
  };
  tempMenuGroup.push(menuItemAdsAndAddons);
  /* menuItemAdsAndAddons */

  /* menuItemReferralAndDiscounts */
  const menuItemReferralAndDiscounts = {
    label: t("AppModuleNames.SuperAdmin.ReferralAndDiscounts"),
    icon: ReferralAndDiscountsIcon,
    path: baseRouteMakerForSuperAdmin(routes.REFERRAL_AND_DISCOUNT_CODES),
  };
  tempMenuGroup.push(menuItemReferralAndDiscounts);
  /* menuItemReferralAndDiscounts */

  /* menuItemFundManagement */
  const menuItemFundManagement = {
    label: t("AppModuleNames.SuperAdmin.FundManagement"),
    icon: FundManagementIcon,
    path: baseRouteMakerForSuperAdmin(routes.FUND_MANAGEMENT),
  };
  tempMenuGroup.push(menuItemFundManagement);
  /* menuItemFundManagement */

  /* menuItemChatAccess */
  const menuItemChatAccess = {
    label: t("AppModuleNames.SuperAdmin.ChatAccess"),
    icon: ChatAccessIcon,
    path: baseRouteMakerForSuperAdmin(routes.CHAT_ACCESS),
  };
  tempMenuGroup.push(menuItemChatAccess);
  /* menuItemChatAccess */

  /* menuItemReviews */
  const menuItemReviews = {
    label: t("AppModuleNames.SuperAdmin.Reviews"),
    icon: ReviewsIcon,
    path: baseRouteMakerForSuperAdmin(routes.REVIEWS),
  };
  tempMenuGroup.push(menuItemReviews);
  /* menuItemReviews */

  /* menuItemUserManagement */
  const menuItemUserManagement = {
    label: t("AppModuleNames.SuperAdmin.UserManagement"),
    icon: UserManagementIcon,
    path: baseRouteMakerForSuperAdmin(routes.USER_MANAGEMENT),
  };
  tempMenuGroup.push(menuItemUserManagement);
  /* menuItemUserManagement */
  
  /* menuItemUserPermissions */
  const menuItemUserPermissions = {
    label: t("AppModuleNames.SuperAdmin.UserPermissions"),
    icon: UserPermissionsIcon,
    path: baseRouteMakerForSuperAdmin(routes.USER_PERMISSIONS),
  };
  tempMenuGroup.push(menuItemUserPermissions);
  /* menuItemReferralAndDiscounts */

  /* menuItemTicketManagement */
  const menuItemTicketManagement = {
    label: t("AppModuleNames.SuperAdmin.TicketManagement"),
    icon: TicketManagementIcon,
    path: baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT),
  };
  tempMenuGroup.push(menuItemTicketManagement);
  /* menuItemTicketManagement */

  /* menuItemFlashMessage */
  const menuItemFlashMessage = {
    label: t("AppModuleNames.SuperAdmin.FlashMessage"),
    icon: FlashMessageIcon,
    path: baseRouteMakerForSuperAdmin(routes.FLASH_MESSAGE),
  };
  tempMenuGroup.push(menuItemFlashMessage);
  /* menuItemFlashMessage */

  /* menuItemNotify */
  const menuItemNotify = {
    label: t("AppModuleNames.SuperAdmin.Notify"),
    icon: NotifyIcon,
    path: baseRouteMakerForSuperAdmin(routes.NOTIFY),
  };
  tempMenuGroup.push(menuItemNotify);
  /* menuItemNotify */

  /* menuItemFAQS */
  const menuItemFAQS = {
    label: t("AppModuleNames.SuperAdmin.FAQS"),
    icon: FaqsIcon,
    path: baseRouteMakerForSuperAdmin(routes.FAQS),
  };
  tempMenuGroup.push(menuItemFAQS);
  /* menuItemFAQS */

  /* menuItemTermsAndCondition */
  const menuItemTermsAndCondition = {
    label: t("AppModuleNames.SuperAdmin.TermsAndCondition"),
    icon: TermsAndConditionIcon,
    path: baseRouteMakerForSuperAdmin(routes.TERMS_AND_CONDITION),
  };
  tempMenuGroup.push(menuItemTermsAndCondition);
  /* menuItemTermsAndCondition */

  return tempMenuGroup;
};
